import { useTranslation } from 'react-i18next';
import {
  Table,
  TableHeader,
  TableRow,
  TableHead,
} from '@/components/ui/table';
import { currencyLabel } from '@/lib/utils/currency';
import type { Contract } from './useContractData';

function formatTime(seconds: number): string {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  return `${hours}h ${minutes}m`;
}

interface ReportSummaryTableProps {
  selectedContract: Contract;
  clientName: string;
  minLabel: string;
  maxLabel: string;
  totalBillableSeconds: number;
  totalBilledPrice: number;
  overTime: string;
  showBilledPrice?: boolean;
}

export function ReportSummaryTable({
  selectedContract,
  clientName,
  minLabel,
  maxLabel,
  totalBillableSeconds,
  totalBilledPrice,
  overTime,
  showBilledPrice = false,
}: ReportSummaryTableProps) {
  const { t } = useTranslation();

  return (
    <div className="border rounded-md mb-4">
      <Table className="[&_th]:!text-center [&_td]:!text-center [&_th]:align-middle [&_td]:align-middle text-xs">
        <TableHeader>
          <TableRow>
            <TableHead className="font-bold border-r" rowSpan={2}>
              {t('clientName')}
            </TableHead>
            <TableHead className="border-r" rowSpan={2}>
              {clientName ?? '-'}
            </TableHead>
            <TableHead className="font-bold border-r">{t('contractNo')}</TableHead>
            <TableHead className="border-r">
              {selectedContract?.name || '-'}
            </TableHead>
            <TableHead className="font-bold border-r">{t('startCreateDate')}</TableHead>
            <TableHead className="border-r">{minLabel}</TableHead>
            <TableHead className="font-bold border-r">{t('totalRunTime')}</TableHead>
            <TableHead className="border-r">{formatTime(totalBillableSeconds)}</TableHead>
            {showBilledPrice && (
              <>
                <TableHead className="font-bold border-r" rowSpan={2}>
                  {t('totalBilled')}
                </TableHead>
                <TableHead className="border-r" rowSpan={2}>
                  {totalBilledPrice.toLocaleString()}{' '}
                  {currencyLabel(selectedContract?.currency)}
                </TableHead>
              </>
            )}
          </TableRow>
          <TableRow>
            <TableHead className="font-bold border-r">{t('contractDate')}</TableHead>
            <TableHead className="border-r">
              {selectedContract?.createdAt
                ? new Date(selectedContract.createdAt).toLocaleDateString()
                : '-'}
            </TableHead>
            <TableHead className="font-bold border-r">{t('endCreateDate')}</TableHead>
            <TableHead className="border-r">{maxLabel}</TableHead>
            <TableHead className="font-bold border-r">{t('upTotalRunTime')}</TableHead>
            <TableHead className="border-r">{overTime}</TableHead>
          </TableRow>
        </TableHeader>
      </Table>
    </div>
  );
}
